import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/697c73333f594f00070ea6cc/restaurantbrand/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/697c73333f594f00070ea6cc/restaurantbrand/src/app/menu/components/MenuCategories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/697c73333f594f00070ea6cc/restaurantbrand/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/697c73333f594f00070ea6cc/restaurantbrand/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/697c73333f594f00070ea6cc/restaurantbrand/src/components/ui/AppImage.tsx");
